export const organizationLoader = {
  listStructure: 'listStructure',
  listStructureLimit: 'listStructureLimit',
  chartStructure: 'chartStructure',
  listEmployee: 'listEmployee',
  listEmployeeLimit: 'listEmployeeLimit',
  chartEmployee: 'chartEmployee',
  detailStructure: 'detailStructure',
  detailEmployee: 'detailEmployee',
  dropdownStructure: 'dropdownStructure',
  dropdownEmployee: 'dropdownEmployee',
};

export const initialStateOrganization = {
  listStructure: true,
  listStructureLimit: true,
  chartStructure: true,
  listEmployee: true,
  listEmployeeLimit: true,
  chartEmployee: true,
  detailStructure: true,
  detailEmployee: true,
  dropdownStructure: true,
  dropdownEmployee: true,
};
